import { render } from "./ProductsItem.vue?vue&type=template&id=4192a973&scoped=true"
import script from "./ProductsItem.vue?vue&type=script&lang=js"
export * from "./ProductsItem.vue?vue&type=script&lang=js"

import "./ProductsItem.vue?vue&type=style&index=0&id=4192a973&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4192a973"]])

export default __exports__